import { Grid } from '@material-ui/core';
import {
  EntityGitlabLanguageCard,
  EntityGitlabMergeRequestsTable,
  EntityGitlabPipelinesTable,
  EntityGitlabReleasesCard,
} from '@immobiliarelabs/backstage-plugin-gitlab';

export const entityRepositoryContent = (
  <Grid container>
    <Grid item md={6} xs={12}>
      <EntityGitlabLanguageCard variant="gridItem" />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityGitlabReleasesCard variant="gridItem" />
    </Grid>
    <Grid item xs={12}>
      <EntityGitlabPipelinesTable />
    </Grid>
    <Grid item xs={12}>
      <EntityGitlabMergeRequestsTable />
    </Grid>
  </Grid>
);
